/**
 * Touch "Run" toggle next to the joystick (ADR-0018: "run instead of walk"). Keyboards hold Shift instead. While it is
 * on, every walking input carries the run bit; the server decides the speed (RUN_SPEED_MULTIPLIER x walking). A real
 * toggle button (aria-pressed), so screen readers and switch users can use it too.
 */
export function RunToggle({ on, onChange }: { on: boolean; onChange(on: boolean): void }) {
  return (
    <button
      type="button"
      className={on ? "run-toggle on" : "run-toggle"}
      aria-pressed={on}
      aria-label={on ? "Running (tap to walk)" : "Run"}
      title={on ? "Running: tap to walk again" : "Tap to run instead of walk"}
      onClick={() => onChange(!on)}
      data-testid="run-toggle"
    >
      {on ? "Running" : "Run"}
    </button>
  );
}
